import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'containsId',
  standalone: true,
})
export class ContainsIdPipe implements PipeTransform {
  transform(assignments: { id: string }[], id: string | null): boolean {
    return assignments.some((assignment) => assignment.id === id);
  }
}
